import Sunrise from "../../../Icons/Sunrise.icon";
import Sunset from "../../../Icons/Sunset.icon";
import LocationMap from "../../LocationMap";
import React, { Fragment } from "react";
const moment = require("moment-timezone");
import "./GeographyAndMeteorology.css";
import PropTypes from "prop-types";

const formatAddress = (suburb, state, postcode) => {
  const addressParts = [ suburb, state, postcode ].filter(Boolean);
  return addressParts.join(', ');
};

export const GeographyAndMeteorology = ({
  id,
  country,
  latitude,
  longitude,
  suburb,
  state,
  postcode,
  temperature,
  icon,
  timezone,
  sunriseTime,
  sunsetTime,
}) => (
  <Fragment>
    <div className="d-flex flex-row justify-content-between align-items-stretch">
      <div className="flex-grow-1 mt-3 d-flex flex-column align-items-start justify-content-between">
        <p>
          <strong>
            {formatAddress(suburb, state, postcode)}
          </strong>
        </p>
        <p className="mb-0">Latitude: {latitude}</p>
        <p>Longitude: {longitude}</p>
      </div>
      <div
        id="map_svg"
        className="col-5 d-flex flex-column align-items-center justify-content-center px-0"
      >
        <LocationMap
          country={country}
          latitude={latitude}
          longitude={longitude}
        />
      </div>
    </div>
    <div className="d-flex flex-row justify-content-between align-items-stretch">
      <div className="col-6 col-sm-5 p-0 m-0 align-items-start justify-content-between">
        {icon
          ?
          <div className={"weather-icon " + icon} />
          : ""
        }
        {temperature !== null
          ?
          <h4 className="h5-sm h4-lg m-0 mb-3 p-0 pl-3">
            {Number.parseFloat(temperature).toFixed(1)}&deg;C
          </h4>
          : ""
        }
      </div>
      <div className="d-flex flex-column col-6 col-sm-7 col-lg-6 justify-content-between align-items-stretch px-0">
        {sunriseTime
          ?
          <div className="d-flex flex-row w-100 m-0 p-0">
            <div className="col-6 d-flex flex-column px-0">
              <i className="fill-white m-0 p-0 pt-3">
                <Sunrise className="fill-white" height="30px" width="50px" />
              </i>
              <p className="m-0 p-0">{moment(sunriseTime, ['HH:mm:ss']).format("h:mm A")}</p>
            </div>
            <div className="col-6 d-flex flex-column px-0">
              <i className="fill-white m-0 p-0 px-0 pt-3">
                <Sunset className="fill-white" height="30px" width="50px" />
              </i>
              <p className="m-0 p-0">{moment(sunsetTime, ['HH:mm:ss']).format("h:mm A")}</p>
            </div>
          </div>
          : ""
        }
        <div className="row w-100 m-0 p-0">
          <p className="m-0 mb-3 p-0">
            Local Time:{" "}
            <span dangerouslySetInnerHTML={{__html: moment().tz(timezone).format("h:mm A,<br>ll")}} />
          </p>
        </div>
      </div>
    </div>
  </Fragment>
);

GeographyAndMeteorology.propTypes = {
  id: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  suburb: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GeographyAndMeteorology/GeographyAndMeteorology.js